export function formHasValue(form: HTMLFormElement, inputName: string): boolean {
    for (let v of new FormData(form).entries()) {
        if (v[0] == inputName)
            return !v[1];
    }
    // value doesn't exist yet in form
    return true;
}